import { render, staticRenderFns } from "./RequestAffiliationView.vue?vue&type=template&id=3e7a3f36&"
import script from "./RequestAffiliationView.vue?vue&type=script&lang=ts&"
export * from "./RequestAffiliationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e7a3f36')) {
      api.createRecord('3e7a3f36', component.options)
    } else {
      api.reload('3e7a3f36', component.options)
    }
    module.hot.accept("./RequestAffiliationView.vue?vue&type=template&id=3e7a3f36&", function () {
      api.rerender('3e7a3f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/member/request-affiliation/RequestAffiliationView.vue"
export default component.exports